export default {
  brand: '#363740',
  modal: {
    valueColor: '#718096',
    borderBottomColor: '#E2E8F0',
  },
  primaryList: {
    header: {
      bgColor: 'rgba(38, 91, 169, 0.2)',
    },
    item: {
      color: '#718096',
      bgColor: 'white',
      borderColor: '#E2E8F0',
    },
  },
  secondaryList: {
    header: {
      bgColor: 'white',
      borderColor: '#E2E8F0',
    },
    item: {
      color: '#718096',
      bgColor: 'white',
      borderColor: '#E2E8F0',
    },
  },
};
